import { Injectable } from "@angular/core";
import { currentRetailerStorageKey } from "@core/constants";
import { GlobalState, Retailer } from "@core/entities";
import { AppState } from "@core/store";
import * as GlobalAction from "@core/store/actions/global.action";
import { AdapterUi } from "@core/store/adapters/global.adapter";
import * as GlobalRed from "@core/store/reducers/global.reducer";
import { select, Store } from "@ngrx/store";
import { StorageMap } from "@ngx-pwa/local-storage";
import { map, take } from "rxjs/operators";

@Injectable()
export class ReportsWindowFacade {
  constructor(private store: Store<AppState>, private storage: StorageMap) {}

  private getUi$ = this.store.pipe(select(GlobalRed.getUiGlobal));

  getPickingPoints$ = this.store.pipe(select(GlobalRed.getSerializedPickingPoints));
  getRetailer$ = this.storage.get(currentRetailerStorageKey).pipe(select((r: Retailer) => r));

  open$ = this.getUi$.pipe(select(ui => ui.openReportsWindow));
  showButton$ = this.getUi$.pipe(select(ui => ui.showReportsWindowButton));
  reports$ = this.store.pipe(select(GlobalRed.getReports));

  setUi(ui: Array<AdapterUi<GlobalState["ui"]>>) {
    this.store.dispatch(GlobalAction.uiGlobal({ ui }));
  }

  getReports() {
    this.getRetailer$
      .pipe(
        take(1),
        map(r => {
          this.store.dispatch(GlobalAction.getReports({ retailerId: r.id }));
        })
      )
      .subscribe();
  }
}
